import CloneError from "./CloneError.mjs";
class ShallowCloneError extends CloneError {}
export default ShallowCloneError;